
define('text!templates/modules/questionnaire/responses/stats/questionnaire-stats.html',[],function () { return '<div class="panel-body questionnaire-stats">\n    <div class="questions-list"></div>\n    <div class="chart"></div>\n</div>\n';});

